import { Drawing } from "./index";

export interface SerializedDrawing {
  id: string;
  pixels: Record<string, boolean>;
  preview: string;
  strokes: number[][];
  currStroke: number;
}

export function serialize(drawing: Drawing): SerializedDrawing {
  return {
    id: drawing.id,
    pixels: drawing.pixels,
    preview: drawing.preview,
    strokes: drawing.strokes,
    currStroke: drawing.currStroke,
  };
}
